import {dateTime, localisedTime} from "services/date";
import {KnownTrigger, KnownTriggerAction} from "types/Trigger";
import deserializeBeacon from "services/ngage/deserializers/beacon";
import deserializePhysicalObject from "services/ngage/deserializers/physical-object";
import deserializeQrCode from "services/ngage/deserializers/qr-code";
import deserializeExhibit from "services/ngage/deserializers/exhibit";
import deserializeMessage from "services/ngage/deserializers/message";
import {TriggerTimings} from "types/TriggerTimings";
import {DateTime, Info} from "luxon";
import deserializeFacility from "./facility";

function localisedTimings(timings: TriggerTimings): TriggerTimings {
    const localTimezone = DateTime.now().zoneName
    const localTimings = {...timings}

    if(localTimings.timezone === localTimezone) return timings

    Info.weekdays().forEach(day => {
        const dayKey = day.toLowerCase() as keyof Omit<TriggerTimings, 'timezone'>
        const constraint = localTimings[dayKey]

        if(constraint.frequency === 'between') {
            constraint.periods = constraint.periods.map(period => [
                localisedTime(period[0], timings.timezone),
                localisedTime(period[1], timings.timezone)
            ])
        }

        localTimings[dayKey] = constraint
    });

    localTimings.timezone = localTimezone

    return localTimings
}

function deserializeTriggerAction(action: any): KnownTriggerAction {
    action.created_at = dateTime(action.created_at)
    action.updated_at = dateTime(action.updated_at)

    if(action.exhibit){
        action.exhibit = deserializeExhibit(action.exhibit)
    }

    if(action.facility){
        action.facility = deserializeFacility(action.facility)
    }

    if(action.message) {
        action.message = deserializeMessage(action.message)
    }

    return action
}

/**
 * Transform the given trigger by deserializing object properties
 *
 * @internal
 * @param trigger
 */
export default function deserializeTrigger(trigger: any): KnownTrigger {
    trigger.enabled_at = dateTime(trigger.enabled_at)
    trigger.created_at = dateTime(trigger.created_at)
    trigger.updated_at = dateTime(trigger.updated_at)

    trigger.timings = localisedTimings(trigger.timings)

    if(trigger.hardware){
        trigger.hardware = trigger.hardware.map((item: any) => {
            switch (item.type){
                case 'beacon':
                    return deserializeBeacon(item)
                case 'physical-object':
                    return deserializePhysicalObject(item)
                case 'qr-code':
                    return deserializeQrCode(item)
                default:
                    return item
            }
        })
    }

    trigger.actions = trigger.actions
        ?.map(deserializeTriggerAction)
        .sort((a: KnownTriggerAction, b: KnownTriggerAction) => a.order - b.order)

    return trigger;
}